import {Switch} from '@wandb/weave/components';
import React, {useState} from 'react';

import {useVideoPlaybackSyncSettings} from '../../hooks/useVideoPlaybackSyncSettings';
import {SettingTitle} from '../common/SettingTitle';
import {
  useMediaSettingsDrawerContext,
  useWorkspaceMediaSettingsDrawer,
} from '../MediaSettingsDrawerContextProvider';

export const VideoPlaybackSyncLoop = () => {
  const {config, updateConfig, unsetConfigField, settingsLevel} =
    useMediaSettingsDrawerContext();
  const {
    isEnabled: isEnabledVideoPlaybackSync,
    isInherited: isInheritedVideoPlaybackSync,
    autoLoop: {isEnabled: isEnabledAutoLoop},
  } = useVideoPlaybackSyncSettings(config, settingsLevel);
  const {
    updateConfig: updateWorkspaceConfig,
    unsetConfigField: unsetWorkspaceConfigField,
  } = useWorkspaceMediaSettingsDrawer();

  const [shouldSyncVideoPlaybackLoop, setShouldSyncVideoPlaybackLoop] =
    useState(isEnabledAutoLoop);

  if (isInheritedVideoPlaybackSync || !isEnabledVideoPlaybackSync) {
    return null;
  }

  return (
    <div className={'flex justify-between'}>
      <SettingTitle
        title="Loop videos"
        description="Automatically restart videos."
        configField="videoPlaybackSyncLoop"
      />
      <Switch.Root
        aria-label="Toggle video playback loop"
        data-test="sync-video-playback-autoplay-switch"
        checked={shouldSyncVideoPlaybackLoop}
        onCheckedChange={newValue => {
          setShouldSyncVideoPlaybackLoop(newValue);
          // Allow the switch to animate before updating the config so that it's more of a smooth
          // transition before the component re-mounts
          setTimeout(() => {
            if (newValue) {
              updateConfig({videoPlaybackSyncLoop: newValue});
              if (settingsLevel !== 'workspace') {
                updateWorkspaceConfig({videoPlaybackSyncLoop: newValue});
              }
            } else {
              unsetConfigField('videoPlaybackSyncLoop');
              if (settingsLevel !== 'workspace') {
                unsetWorkspaceConfigField('videoPlaybackSyncLoop');
              }
            }
          }, 100);
        }}>
        <Switch.Thumb checked={shouldSyncVideoPlaybackLoop ?? false} />
      </Switch.Root>
    </div>
  );
};
